@if (type === SearchType.Page && isPage(searchResults)) {
    <adapt-search-row-page [showDetails]="false"
                           [keyword]="keyword"
                           [result]="searchResults"></adapt-search-row-page>
}

@if (type === SearchType.PersonTeamRole && !isPage(searchResults)) {
    @if (SearchService.isPerson(searchResults); as person) {
        <adapt-search-row-person [keyword]="keyword"
                                 [result]="person"></adapt-search-row-person>
    }
    @if (SearchService.isRole(searchResults); as role) {
        <adapt-search-row-role [showLabels]="false"
                               [showMatches]="false"
                               [keyword]="keyword"
                               [result]="role"></adapt-search-row-role>
    }
    @if (SearchService.isTeam(searchResults); as team) {
        <adapt-search-row-team [showLabels]="false"
                               [showMatches]="false"
                               [keyword]="keyword"
                               [result]="team"></adapt-search-row-team>
    }
}
